// extracted by mini-css-extract-plugin
module.exports = {"input-switch":"__input-switch__08Bsk","md":"__md__3VpYk","sm":"__sm__RRRot","xs":"__xs__CQlRN","xxs":"__xxs__iWtQd","checked":"__checked__Wl3R5","focused":"__focused__DU7cL"};